// src/components/Footer.tsx
import React from "react";
import { getAppVersionLabel } from "../config/version";

export default function Footer(): React.ReactElement {
  const versionLabel = getAppVersionLabel();
  return (
    <footer className="bg-white border-t border-slate-200 py-4 px-8 text-sm text-slate-500 flex justify-between items-center">
      <p>&copy; {new Date().getFullYear()} Port Health Authority. All rights reserved.</p>
      <div className="flex gap-4 items-center">
        <span className="text-xs uppercase tracking-wide text-slate-400">{versionLabel}</span>
        <a href="/privacy" className="hover:text-slate-700">
          Privacy Policy
        </a>
        <a href="/terms" className="hover:text-slate-700">
          Terms of Service
        </a>
        <a href="/help" className="hover:text-slate-700">
          Help
        </a>
      </div>
    </footer>
  );
}
